// extracted by mini-css-extract-plugin
export default {"quotaInput":"AnswerQuotaInput_quotaInput__-ozLI","disabled":"AnswerQuotaInput_disabled__c6jSZ"};